import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Collapse } from '@mui/material';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import Alert from 'shared/components/alert/alert';

import { useGatewaysContextProvider } from 'features/gateway/context/gateway-provider';
import styles from 'features/gateway/views/gateway-details/gateway-settings/gateway-settings-mediaserver.module.scss';

const GatewaySettingsMediaserver = () => {
  const { t } = useTranslation('gateway');

  const {
    gatewayDetailsHook: { viewingMode },
  } = useGatewaysContextProvider();

  const {
    control,
    watch,
    formState: { dirtyFields },
  } = useFormContext();

  const isViewing = viewingMode === 'viewing';
  const isEditing = viewingMode === 'editing';

  const shouldMonitorMediaserverValue = watch('shouldMonitorMediaserver');
  const isAlertVisible = isEditing && dirtyFields.shouldMonitorMediaserver && shouldMonitorMediaserverValue;

  return (
    <div className={styles.container}>
      <Collapse in={isAlertVisible}>
        <div className={styles.explanationRow}>
          <Alert body={t('details.settings.configurationRemarkMediaserverMonitoring')} />
        </div>
      </Collapse>
      <div className={styles.configurationRow}>
        <Typography variant="subtitle1">{t('details.information.mediaserverMonitoring')}</Typography>
        <Controller
          name="shouldMonitorMediaserver"
          control={control}
          render={({ field }) => <Switch {...field} type="checkbox" checked={field.value} disabled={isViewing} />}
        />
      </div>
    </div>
  );
};

export default GatewaySettingsMediaserver;
